import React from 'react';
import * as GlobalPanelEntry from './global-panels';

const componentKeys = Object.keys(GlobalPanelEntry);

export const GlobalPanelManager = React.memo(() => {
  return (
    <>
      {componentKeys.map((key) => {
        const Component = GlobalPanelEntry[key as keyof typeof GlobalPanelEntry];
        return <Component key={key} />;
      })}
    </>
  );
});

GlobalPanelManager.displayName = 'GlobalPanelManager';
